import React, { useState } from "react";
import { PaystackButton } from "react-paystack";
//

const GiveForm = () => {
  const publicKey = process.env.REACT_APP_PAYSTACK_PUBLIC_KEY;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [amount, setAmount] = useState("");

  const componentProps = {
    email,
    amount,
    metadata: {
      name,
      phone,
    },
    publicKey,
    text: "Give Now",
    onSuccess: () => {
      setEmail("");
      setName("");
      setPhone("");
    },
  };

  return (
    <div className="checkout bg-white px-8 pt-2 py-8 rounded-lg myShadow">
      <div className="checkout-form">
        <div className="mt-10 checkout-field">
          <label htmlFor="fullName" class="block mb-2 text-sm font-bold ">
            Your Name
          </label>
          <input
            type="text"
            id="name"
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-3"
            placeholder="Your Name"
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="mt-10 checkout-field">
          <label htmlFor="first_name" class="block mb-2 text-sm font-bold ">
            Your Email
          </label>
          <input
            type="email"
            id="email"
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-3"
            placeholder="Your Email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="mt-10 checkout-field">
          <label htmlFor="first_name" class="block mb-2 text-sm font-bold ">
            Your Phone Number
          </label>
          <input
            type="text"
            id="phone"
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-3"
            placeholder="Your Phone Number"
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </div>
        <div className="mt-10 checkout-field">
          <label htmlFor="first_name" class="block mb-2 text-sm font-bold ">
            How much would you like to give?
          </label>
          <input
            type="number"
            id="amount"
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-3"
            placeholder="Enter Amount Here"
            onChange={(e) => setAmount(`${e.target.value}00`)}
            required
          />
        </div>
        <div className="mt-10">
          <PaystackButton
            className="paystack-button bg-dark-blue rounded-md px-4 py-3 md:px-8 md:py-4 text-white"
            {...componentProps}
          />
        </div>
      </div>
    </div>
  );
};

export default GiveForm;
